import {create} from "zustand";

export const useAthletesStore = create((set, get) => ({
    athletes:{},
    setAthletes: (athletes) => set( () => ({athletes: athletes}))
}))
